import { render, staticRenderFns } from "./system_select.vue?vue&type=template&id=4f20d47c&scoped=true"
import script from "./system_select.vue?vue&type=script&lang=js"
export * from "./system_select.vue?vue&type=script&lang=js"
import style0 from "./system_select.vue?vue&type=style&index=0&id=4f20d47c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f20d47c",
  null
  
)

export default component.exports